import React from 'react';
import { Switch } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './Header.scss';
import analytics from '../../services/analytics';

const ThemeSwitcher = ({ theme, toggleTheme }) => {
  const { t } = useTranslation('common');
  const isDarkTheme = theme === 'vs-dark';

  const handleToggle = checked => {
    // Send both source and destination theme so analytics can verify transitions
    analytics.trackThemeChanged(isDarkTheme ? 'dark' : 'light', checked ? 'dark' : 'light');
    toggleTheme(checked);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span
        className={classNames({
          [styles['gray-text']]: isDarkTheme,
          [styles['black-text']]: !isDarkTheme,
        })}
        style={{ fontSize: '14px', marginRight: '4px' }}
      >
        {t('editor.theme.light')}
      </span>

      <Switch
        checked={isDarkTheme}
        onChange={handleToggle}
      />

      <span
        className={classNames({
          [styles['white-text']]: isDarkTheme,
          [styles['gray-text']]: !isDarkTheme,
        })}
        style={{ fontSize: '14px', marginLeft: '4px' }}
      >
        {t('editor.theme.dark')}
      </span>
    </div>
  );
};

export default ThemeSwitcher;
